var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclaimationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5999 6.49999C11.5999 9.59279 9.09271 12.1 5.99991 12.1C2.90711 12.1 0.399902 9.59279 0.399902 6.49999C0.399902 3.4072 2.90711 0.899994 5.99991 0.899994C9.09271 0.899994 11.5999 3.4072 11.5999 6.49999ZM6.69991 3.69999C6.69991 4.08659 6.38651 4.39999 5.99991 4.39999C5.61331 4.39999 5.29991 4.08659 5.29991 3.69999C5.29991 3.31339 5.61331 2.99999 5.99991 2.99999C6.38651 2.99999 6.69991 3.31339 6.69991 3.69999ZM5.29991 5.79999C4.91331 5.79999 4.59991 6.11339 4.59991 6.49999C4.59991 6.88659 4.91331 7.19999 5.29991 7.19999V9.29999C5.29991 9.68659 5.61331 9.99999 5.99991 9.99999H6.69991C7.08651 9.99999 7.39991 9.68659 7.39991 9.29999C7.39991 8.9134 7.08651 8.59999 6.69991 8.59999V6.49999C6.69991 6.11339 6.38651 5.79999 5.99991 5.79999H5.29991Z",
    fill: "#60A5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimationIcon);
export default __webpack_public_path__ + "static/media/exclaimation-icon.384cce7590279ba6ebc24181fd31eb04.svg";
export { ForwardRef as ReactComponent };